<template>
  <v-main>

      <v-container fluid class="mt-5 px-0">
        <div class="closed">
              本イベントは終了しました
        </div>
      </v-container>

    <v-container fluid id="title-and-cpoy" class="py-12">
      <v-container class="text-center">
        <div v-if="isDebug">
          【デバッグモード】
          <div v-if="!isMobileDevice()">
            <div>PCで表示</div>
          </div>
          <div v-if="isMobileDevice()">
            <div>モバイルで表示</div>
          </div>
        </div>
      </v-container>

      <!-- ハッシュタグ -->
      <v-responsive class="font-weight-bold text-sm-center text-h5 mb-3" style="color:#ecf8ac;">
        <v-layout justify-center>
          <p>#nakedinc #ネイキッドインク</p>
        </v-layout>
      </v-responsive>


      <!-- リード文 -->
      <v-responsive class="mx-auto text-block mt-8">
        <h2 class="text-h6 font-weight-bold text-center">
          NAKEDの最新アート展は<br>
          占い×テクノロジー×アートの超体験！
        </h2>
      </v-responsive>
      <v-responsive class="mx-auto text-body-1 font-weight-bold text-center text-block mt-8" style="line-height:1.8;">
        <p>『FLOWERS BY NAKED』や<br class="br-sm">『NAKED SAUNA & SPA』など、<br>
          これまで数々の新たなクリエイティブ体験を<br class="br-sm">生み出してきたNAKED, INC.<br class="br-sm">（ネイキッドインク）。<br>
          占いブームと呼ばれる昨今、<br class="br-sm">現代では占いは依存するものではなく、<br class="br-sm">自分を知るひとつのツール。<br>
          NAKEDが描く圧倒的世界観と、<br class="br-sm">AIをはじめとしたテクノロジーアートで、<br class="br-sm">
          「アナタを知る」超占い体験をお届けします。</p>
      </v-responsive>


      <!-- 新型コロナウィルス感染症対策について -->
      <v-responsive class="pt-15">
        <DialogCovid19 />
      </v-responsive>


      <!-- リンクボタン -->
      <v-container>
        <v-layout v-bind="binding" class="pt-10">
          <v-flex xs12 sm4 offset-sm-2 text-center py-10>
            <v-btn disabled color="#fd0a8c" :href="ticket_url" width="90%" height="50" target="_blank" class="border-white">
              <span class="text-sm-body-2 text-md-body-1">
                チケット購入
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm4 text-center>
            <p class="">チケット購入済の方へ</p>
            <v-btn disabled dark :href="uranai_url" width="90%" height="50" target="_blank" class="border-white">
              <span class="text-sm-body-2 text-md-body-1">
                来場前の事前登録はこちら
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout class="pt-3" justify-center>
          <p class="text-caption text-sm-subtitle-2 text-block">【注意事項】
            ※イベントをお楽しみいただくにはスマートフォンが必要です。スマートフォンをお持ちでない場合は体験を
            お楽しみいただくことができません。予めご了承ください。
            スマートフォンの貸し出しはしておりません。<br>
            （インターネット通信機能があるタブレットもご利用可能ですが端末によっては一部表示が乱れる可能性がございます。）</p>
        </v-layout>

      </v-container>


      <!-- ティザー動画へリンク -->
      <v-row justify="center" class="pt-10">
        <v-col cols="12" sm="8">
          <v-responsive :aspect-ratio="16/9">

            <iframe width="100%" height="100%"
              src="https://www.youtube.com/embed/vRF-mExfkB8?loop=1&playlist=vRF-mExfkB8" title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>

          </v-responsive>
        </v-col>
      </v-row>

    </v-container>


    <!-- Twitter Embed -->
    <v-container class="text-center py-15">
      <h2 class="h2 font-weight mb-5">
        INFORMATION
      </h2>
      <TweetEmbed />
    </v-container>


    <!-- Contents -->
    <v-container fluid light id="contents" class="py-15 pl-0 pr-0" style="color:#555;">
      <v-container id="contents" class="text-center mb-5">
        <h2 class="h2 font-weight">
          CONTENTS
        </h2>
      </v-container>

      <!-- コンテンツスライダー -->
      <SwiperContents />
    </v-container>


    <!-- アーティスト -->
    <v-container fluid id="artist" class="pt-15">
      <h2 class="text-center">
        ARTIST
      </h2>
      <v-container grid-list-xl class="mt-5 pb-15">
        <v-layout v-bind="binding" v-for="({thumbnail, title, caption}, i) in artist" :key="i">
          <v-flex xs12 sm5 offset-sm-1 order-md-first>
            <v-img :src="thumbnail">
            </v-img>
          </v-flex>
          <v-flex order-md-last xs12 sm4 class="pl-lg-5">
            <v-responsive class="mx-auto headline font-weight mb-3">
              <p class="title text-center text-sm-left"><small>原案・総合演出</small><br>村松 亮太郎</p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light">
              <p class="caption">{{caption}}</p>
            </v-responsive>
            <v-responsive>
              <div><a href="https://ryotaro-muramatsu.com" target="_blank"
                  style="color:white;">https://ryotaro-muramatsu.com</a></div>
              <div>
                <p class="caption">■Official Instagram ：<a href="https://www.instagram.com/ryo_naked/" target="_blank"
                    style="color:white;">@ryo_naked</a></p>
              </div>
            </v-responsive>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>


    <!-- 監修者 -->
    <v-container fluid light id="director" style="color:#555;" class="pt-15">
      <h2 class="text-center">
        占い監修者
      </h2>
      <v-container grid-list-xl>
        <v-layout v-bind="binding" v-for="({thumbnail, title, description}, i) in director" :key="i" class="pt-5">
          <v-flex xs12 sm4 order-md-last class="pb-5">
            <v-img :src="thumbnail">
            </v-img>
          </v-flex>
          <v-flex xs12 sm5 offset-sm1 order-md-first>
            <v-responsive class="mx-auto headline font-weight mb-3">
              <p class="title text-center text-sm-left"><small>占い全体監修</small><br>真木あかり（まきあかり）</p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light">
              <p class="caption">{{description}}</p>
            </v-responsive>
            <v-responsive class="mt-5 caption">
              <div>■Official Twitter ：<a href="https://twitter.com/makiakari" target="_blank"
                  style="color:#555;">https://twitter.com/makiakari</a></div>
              <div>■Official Instagram ：<a href="https://www.instagram.com/maki_akari/" target="_blank"
                  style="color:#555;">https://www.instagram.com/maki_akari/</a></div>
              <div>■Official Blog：<a href="http://makiakari.hatenablog.com/" target="_blank"
                  style="color:#555;">http://makiakari.hatenablog.com/</a></div>
            </v-responsive>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>


    <!-- 技術協力 -->
    <v-container fluid light id="support" style="color:#555;" class="pt-10">

      <v-container grid-list-xl>
        <v-container v-for="({thumbnail, title, description, description2}, i) in support" :key="i">
          <v-flex xs12 class="mx-auto text-block">
            <v-responsive class="mx-auto text-center mb-3">
              <p class="text-h6">夢診断技術協力・Technosophics Ltd</p>
              <p class="text-caption">（テクノソフィックス）</p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light">
              <p class="caption">{{description}}</p>
            </v-responsive>
            <v-responsive>
              <div>
                <p class="caption">■Official Site：<a href="https://www.technosophics.com/" target="_blank"
                    style="color:#666;">https://www.technosophics.com/</a>
                </p>
              </div>
            </v-responsive>
          </v-flex>
          <v-flex xs12 class="mt-10 mx-auto text-block">
            <v-responsive class="mx-auto text-center mb-3">
              <p class="text-h6">フラワーエッセンス監修・細川知子</p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light">
              <p class="caption">{{description2}}</p>
            </v-responsive>
          </v-flex>
        </v-container>
      </v-container>
    </v-container>


    <!-- 真木あかりの西洋占星術による詳細鑑定付プレミアムチケット -->
    <v-container class="pt-15" fluid id="tickets_maki" v-for="({description, term, date, notice, price}, i) in ticket"
      :key="i">
      <h2 class="text-center">
        TICKET
      </h2>
      <h3 class="text-center mt-10">
        限定先行プレミアムチケット
      </h3>
      <p class="text-center font-weight-bold pt-10 text-decoration-line-through">
        <small>6月30日〜7月16日まで<br>限定先行プレミアムチケット2種を販売</small></p>
      <p class="title text-center mt-5 text-decoration-line-through">真木あかりの西洋占星術による<br
          class="br-sm">詳細鑑定付プレミアムチケット<br>5,000円</p>

      <v-container class="mt-10 pb-15">
        <v-layout v-bind="binding">
          <v-flex xs12 sm5 offset-sm1 order-md-first class="pb-5">
            <TicketsMaki />
          </v-flex>
          <v-flex xs-12 sm5 order-md-last class="pl-sm-10">
            <v-responsive>
              <div>
                <ul class="data-list text-decoration-line-through">
                  <li>販売期間: {{term}}</li>
                  <li>金額：{{price}}</li>
                  <li class="caption">{{notice}}</li>
                </ul>
                <ul class="caption data-list mt-5">
                  <li>※『人気占い師・真木あかりの西洋占星術による詳細鑑定』を受けるには、公式占いサイト「NAKED URANAI」への会員登録が必要です。ご来場前に必ず事前登録を行っていただく様お願いいたします。
                  </li>
                  <li>※事前登録期間：6月30日（水）12:00〜7月16日（金）23:59迄</li>
                  <li>※事前登録期間を過ぎると鑑定を受ける事は出来ませんので予めご了承ください。</li>
                  <li>※鑑定は日本国内で出生された方のみ受けることが可能です。</li>
                  <li>※真木あかりによる個別鑑定の結果は、8月上旬以降順次メールにてご連絡いたします。</li>
                </ul>
                <v-row class="mt-5">
                  <v-col cols="12" sm="8" md="6">
                    <v-btn disabled light :href="ticket_url" width="100%" height="50" target="_blank"
                      class="border-white">
                      <span class="text-sm-body-2 text-md-body-1">
                        SOLD OUT
                      </span>
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </div>
            </v-responsive>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>

    <!-- オーラ限定メッセージ付プレミアムチケット -->
    <v-container fluid light id="tickets_ewa" style="color:#555;" class="py-15">

      <h3 class="text-center mt-5">オーラ鑑定メッセージ付<br class="br-sm">プレミアムチケット</h3>
      <v-row>
        <v-col xs="12" sm="10" offset-sm="1" md="8" offset-md="2">
          <p class="text-body-1 text-center mt-5">
            「共感覚」として色でエネルギーを感じ取るewaによるオーラカラー診断＆あなたのオーラから読み解く自身の特質や状態が分かる個別メッセージが入ったオーラカラー解説BOOK（データ）がメールで届くプレミアムチケット</p>
        </v-col>
      </v-row>

      <v-container class="pt-10" grid-list-xl>
        <v-layout v-bind="binding" v-for="({term, date, notice, price}, i) in aura" :key="i">
          <v-flex xs12 sm5 offset-sm1 order-md-first class="pb-5">
            <TicketsEwa />
          </v-flex>
          <v-flex xs12 sm5 order-md-last class="pl-sm-10">
            <v-responsive>
              <div>
                <ul class="data-list text-decoration-line-through">
                  <li>販売期間: {{term}}</li>
                  <li>金額：{{price}}</li>
                  <li class="caption">{{notice}}</li>
                </ul>

                <div class="caption mt-3">
                  <p>※『オーラ鑑定』を受けるには、必ず登録期間内にNAKED URANAI公式サイトへの会員登録が必要です。<br>
                    ※事前登録期間を過ぎると鑑定を受ける事は出来ませんので予めご了承ください。<br>
                    ※事前登録期間：6月30日（水）12:00〜7月16日（金）23:59迄</p>
                  <p>
                    ※オーラ鑑定用にGoogleアカウントをお持ちでない方は、googleアカウント作成をしていただく必要がございます。 <br>
                    ※小人チケットをご購入の方へ 9歳以下のお子様はオーラの色が定まりにくいため、10歳以上のお子様を今回のオーラ鑑定対象とさせていただきます。予めご了承ください。 </p>
                </div>
                <v-row class="mt-5">
                  <v-col cols="12" sm="8" md="6">
                    <v-btn disabled light color="#fd0a8c" :href="ticket_url" width="100%" height="50" target="_blank"
                      class="border-white">
                      <span class="text-sm-body-2 text-md-body-1">
                        SOLD OUT
                      </span>
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </div>
            </v-responsive>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-xl class="mt-15">
        <v-layout v-bind="binding" v-for="({thumbnail, title, description}, i) in ewa" :key="i">
          <v-flex xs12 sm5 offset-sm-1 order-md-first>
            <v-img :src="thumbnail">
            </v-img>
          </v-flex>
          <v-flex xs12 sm5 order-md-last>
            <v-responsive class="mx-auto headline font-weight mb-3">
              <p class="title">ewaプロフィール</p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light">
              <p class="caption">{{description}}</p>
              <div>
                <p class="caption">ewa83：<a href="https://instagram.com/ewa83_ewa83" target="_blank"
                    style="color:#555;">https://instagram.com/ewa83_ewa83</a>
                </p>
              </div>
            </v-responsive>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>

    <!-- チケットテーブル -->
    <v-container fluid class="py-15">
      <TicketTable />
      <v-layout>
        <v-flex xs12 sm8 offset-sm-2 md6 offset-md-3 class="text-center">
          <v-btn disabled color="#fd0a8c" :href="ticket_url" width="100%" height="50" target="_blank" class="border-white">
            <span class="text-sm-body-2 text-md-body-1">
              チケット購入
            </span>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-container grid-list-xl>
        <v-layout class="mt-10">
          <v-flex xs12 sm10 offset-sm-1>
            <p class="text-caption text-sm-subtitle-1">【注意事項】</p>
            <h5>●ご来場前に必ずご確認をお願いいたします。</h5>
            <ul class="data-list">
              <li class="text-h6 font-weight-bold mt-3">
                ※イベントをお楽しみいただくにはスマートフォンが必要です。スマートフォンをお持ちでない場合は体験を お楽しみいただくことができません。予めご了承ください。スマートフォンの貸し出しはしておりません。</li>
              <li class="text-indent--05">（インターネット通信機能があるタブレットもご利用可能ですが端末によっては一部表示が乱れる可能性がございます。）</li>
              <li class="text-h6 font-weight-bold">※本展は、お客様の混雑緩和・安全対策等のため、事前予約制（日時指定券）を導入しています。</li>
              <li class="text-h6 font-weight-bold">※ご入場いただくにはNAKED URANAI公式サイトへの会員登録（無料）が必要です。</li>
              <li class="text-h6 font-weight-bold">
                ※ベビーカーでの入場はお断りしています。受付前にベビーカー置き場をご用意していますので、そちらをご利用ください。但し、ベビーカーの盗難、紛失、破損に関しては責任を負いかねますので、お客様個人での管理をお願いいたします。
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm10 offset-sm-1 class="caption font-weight-bold" style="color:#ecf8ac;">
            <p>●チケットご購入の際の注意事項</p>
            <ul class="data-list">
              <li style="font-size: 1.2em">※ご購入・お申し込みにはtv asahi iDの会員登録が必須です。<br><span
                  class="text-caption">（会員登録は無料です。入会費・年会費・登録料は一切かかりませんが、
                  その際に発生する通信費はお客様のご負担となります。画面に従い、会員登録を行ってください。）</span></li>
              <li style="font-size: 1.2em;">※チケットは1枚ごとにシステム利用料110円/枚が必要です。</li>
              <li style="font-size: 1.2em;">※NAKED URANAI会場窓口でご購入の場合は上記販売価格より一律プラス400円となります。</li>
              <li style="font-size: 1.2em;">※お盆を含む8月10日、11日、12日、13日、16日は土日祝料金となります。</li>
              <li class="mt-2">
                ※混雑緩和のため、指定された入場時間より前にご来場はできません。30分ごとの入場時間内にお越しいただければご入場いただけますが混雑状況によって、入場案内開始時間よりも会場内への入場が遅くなる場合がございます。
              </li>
              <li>※オンラインチケットの販売状況により当日会場窓口券は売り切る場合があります。売り切れの場合は販売できませんので予めご了承ください。</li>
              <li>※発券後は、電子チケット券面の注意書きを必ずご確認ください。</li>
              <li>※本展は完全入れ替え制ではございません。多くのお客様にお楽しみいただくため、譲り合ってのご体験をお願いいたします。</li>
              <li>※チケット1枚につきおひとり様のご入場ができます。再入場はできません。</li>
              <li>※いかなる場合でもチケットの払い戻し、再発行はいたしません。</li>
              <li>※新型コロナウイルスの感染拡大状況により、内容・開催スケジュールの変更、または中止になる可能性があります。</li>
              <li>※ご来場直前には必ず公式ＨＰやＳＮＳで状況をご確認の上、ご来場くださいますようよろしくお願い致します。</li>
              <li>※3歳児以下無料。</li>
              <li>※表示は全て税込価格です。</li>
            </ul>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>


    <!-- OUTLINE -->
    <v-container fluid light id="outline" class="py-15" style="color:#555;">
      <v-container grid-list-xl>
        <v-layout v-bind="binding" v-for="({title, date, time, map, price}, i) in outline" :key="i">

          <v-flex xs12 sm4 offset-sm-1 class="text-center text-md-left">
            <h2 class="font-weight">
              OUTLINE
            </h2>
            <v-responsive class="mx-auto headline font-weight mt-10">
              <p class="subtitle-1 font-weight-bold">名称</p>
              <p class="text-sm-body-1">NAKED URANAI<br class="br-sm"><small>（ネイキッドウラナイ）</small></p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light mt-5">
              <p class="subtitle-1 font-weight-bold">開催期間</p>
              <p class="text-sm-body-1">{{date}}</p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light mt-5">
              <p class="subtitle-1 font-weight-bold">時間</p>
              <p class="text-sm-body-1">{{time}}</p>
            </v-responsive>
            <v-responsive class="mx-auto font-weight-light mt-5">
              <p class="subtitle-1 font-weight-bold">会場</p>
              <p class="text-sm-body-1">渋谷ヒカリエ 9階 ヒカリエホール ホールB <br>
                〒150-8510 東京都渋谷区渋谷２丁目２１−１</p>
              <p class="caption">JR線・京王井の頭線「渋谷駅」と2階連絡通路で直結<br>
                東京メトロ銀座線「渋谷駅」と1階で直結<br>
                東急東横線・田園都市線・東京メトロ半蔵門線・副都心線「渋谷駅」B5出口と直結</p>
            </v-responsive>
          </v-flex>
          <v-flex xs12 sm6>
            <v-img :src="map">
            </v-img>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm10 offset-sm-1 class="text-center text-md-left">
            <v-responsive class="mx-auto font-weight-light">
              <p class="subtitle-1 font-weight-bold">お問い合わせ</p>
              <p class="text-sm-body-1">NAKED URANAI運営事務局<br>
                MAIL：jimukyoku@growb.co.jp<br>（6月30日〜8月27日）<br>10:00～20:00</p>
              <p class="caption">※お問い合わせには順次回答をいたしておりますが、ご回答までに数日いただく場合がございます。予めご了承ください。</p>

              <p class="text-sm-body-1">【チケットに関するお問い合わせ】</p>
              <p>テレ朝チケット お問い合わせフォーム<br>
                <a href="https://www.tv-asahi.co.jp/ticket/contact.html"
                  target="_blank">https://www.tv-asahi.co.jp/ticket/contact.html</a>
              </p>
              <p class="caption mt-3">※お問い合わせには順次回答をいたしておりますが、ご回答までに数日いただく場合がございます。予めご了承ください。</p>
            </v-responsive>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- 韓ドラ展バナー -->
      <v-container class="mt-2">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3">
            <p class="text-center text-sm-left">[ホールA催事]</p>
            <a class="is-disabled" href="https://kandoraten.jp/" target="_blank">
              <v-img :src="kandoraten"></v-img>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <!-- CREDIT -->
    <v-container fluid id="outline" class="py-15">

      <v-layout v-bind="binding">

        <v-flex xs12 class="text-center">

          <v-responsive class="mx-auto font-weight-light mt-5">
            <p class="subtitle-1 font-weight-bold mb-5">企画・演出・制作</p>
            <a :href="corporate_url" target="_blank">
              <v-img :src="corporate_logo" max-width="300px" class="mx-auto">
              </v-img>
            </a>
            <p class="text-subtitle-2 mt-5">NAKED, INC. (株式会社ネイキッド)</p>

            <p class="text-caption text-sm-body-1 text-block mx-auto mt-7">1997年、村松亮太郎がディレクターやデザイナー、
              ライターとともに設立したクリエイティブカンパニ
              ー。アート、エンターテインメント、カルチャー、
              伝統、教育、音楽、都市、食、スポーツなど、
              LIFE(生活)のあらゆるSCENE(シーン)において新た
              な体験や価値を生み出している。</p>
            <a class="body-1" href="https://naked.co.jp" target="_blank" style="color:#fff;">https://naked.co.jp</a>
          </v-responsive>
          <v-responsive class="mx-auto font-weight-light mt-10">
            <p class="subtitle-1 font-weight-bold">特別協力</p>
            <p class="text-caption text-sm-body-1 text-block mx-auto mt-5">
              渋谷ヒカリエ、株式会社星光技研、<a href="https://shop.fian-flower.com/" target="_blank" class="white--text">FIAN</a>
              、<a href="https://fujifilm.com/jp/" target="_blank"
                class="white--text">富士フイルム株式会社</a>（超短焦点プロジェクター「FP－Z5000」、
              電気音響変換フィルム「B.E.A.T.」 ）、<a href="http://www.flora-kumi.jp/" target="_blank" class="white--text">FLORA</a>
              、<a href="http://www.displaymuseum.co.jp/" target="_blank" class="white--text">横浜ディスプレイミュージアム</a>（五十音順）
            </p>
          </v-responsive>
          <v-responsive class="mx-auto font-weight-light mt-10">
            <p class="subtitle-1 font-weight-bold">主催
            </p>
            <p class="text-body-1">NAKED URANAI製作委員会</p>
          </v-responsive>
        </v-flex>
      </v-layout>

    </v-container>

    <v-container class="text-center">
      <a v-smooth-scroll href="#app" class="mx-auto text-h6 font-weight-light white--text text-decoration-none">
        <span class="allow-top">＞</span>TOP<span class="allow-top">＞</span>
      </a>
    </v-container>


    <v-footer dark>
      <!-- NAKEDリンク -->
      <v-container class="pt-10">
        <h4 class="text-center">NAKED作品が楽しめる近隣スポット</h4>
        <v-layout justify-center class="text-center mt-5">
          <v-flex xs12>
            <a class="white--text text-decoration-none" href="https://www.tokyotower.co.jp/" target="_blank">
              東京タワー
            </a>/
            <a class="white--text text-decoration-none" href="http://www.aqua-park.jp/special/floweraquarium2021/
" target="_blank">
              マクセル アクアパーク品川
            </a>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- SNSリンク -->
      <v-container id="links" class="text-center py-10">
        <v-responsive class="mx-auto" max-width="400">
          <v-row>
            <v-col v-for="({icon, url}, i) in links" :key="i" align="center" justify="center">
              <a :href="url" target="_blank">
                <v-img width="36" :src="icon" style="filter:brightness(10);">
                </v-img>
              </a>
            </v-col>
          </v-row>
        </v-responsive>
      </v-container>
      <v-container class="text-center">
        <span class="white--text">&copy; {{ new Date().getFullYear() }} NAKED, inc.</span>
      </v-container>
    </v-footer>


  </v-main>
</template>



<script>
  import isMobile from "ismobilejs";
  import SwiperContents from './Swiper_contents';
  import TweetEmbed from './TweetEmbed';
  import DialogCovid19 from './DialogCovid19';
  import TicketsMaki from './Swiper_tickets_maki';
  import TicketsEwa from './Swiper_tickets_ewa.vue';
  import TicketTable from './TicketTable';

  export default {

    name: 'NakedLP',
    components: {
      SwiperContents,
      TweetEmbed,
      DialogCovid19,
      TicketsMaki,
      TicketsEwa,
      TicketTable
    },


    computed: {
      binding() {
        const binding = {}

        if (this.$vuetify.breakpoint.xsOnly) binding.column = true

        return binding
      },
    },


    data: () => ({

      // ハッシュタグ
      hashtag: '#nakedinc #ネイキッドインク',

      // チケット購入サイトURL
      ticket_url: 'https://ticket.tv-asahi.co.jp/ex/project/H5RIhbjzdY',

      // 占い公式サイトURL
      uranai_url: 'https://uranai.naked.works/',

      // 会社ロゴ
      corporate_logo: './Images/NAKED,INC._Logotype_w.svg',

      // 会社ロゴからの接続先
      corporate_url: 'https://naked.co.jp',

      // お問い合わせの接続先
      contact_url: 'https://naked.co.jp/contact/',

      kandoraten: './Images/kandora_banner.jpg',



      // ARTIST情報
      //
      // thumbnail => サムネイル画像
      // title => タイトル
      // description => 詳細説明
      artist: [{
        thumbnail: './Images/profile_RyotaroMuramatsu.jpg',
        caption: 'アーティスト。NAKED, INC.代表。大阪芸術大学客員教授。長野県・阿智村ブランディングディレクター。 1997年にクリエイティブカンパニーNAKED, INC.を設立以来、映像や空間演出、地域創生、伝統文化など、あらゆるジャンルのプロジェクトを率いてきた。映画の監督作品は長編/短編合わせて国際映画祭で48ノミネート&受賞。2018年からは個人アーティストとしての活動を開始し、国内外で作品を発表。 2020年には、分断の時代に平和への祈りで世界を繋ぐネットワーク型のアートプロジェクト「Breath / Bless Project」を立ち上げ、世界各地での作品設置に取り組む。'
      }, ],

      // 監修者
      //
      // thumbnail => サムネイル画像
      // title => タイトル
      // description => 詳細説明
      director: [{
        thumbnail: './Images/profile_AkariMaki.jpg',
        description: '占い師。学習院大学卒業後、フリーライターなどを経て占いの道に。『タロットであの人の気持ちがわかる本』（説話社）、『2021年上半期12星座別あなたの運勢』（幻冬舎）や女性誌での連載など、著書・連載・アプリ監修多数。占星術や四柱推命で運命を紐解き、人が自分の人生をより良く生きるためのアドバイスを行っている。'
      }],

      // 技術協力
      //
      // thumbnail => サムネイル画像
      // title => タイトル
      // description => 詳細説明
      support: [{
        thumbnail: './Images/contents.jpg',
        description: '「魂に響くテクノロジーを生み出すこと」をミッションに、元 NASA（米国航空宇宙局）コンピュータ・サイエンティストと心理学専門家のチームにより２０１２年イギリスにて設立。 システム研究開発、ライセンシング、関連サービスの提供を行う。本アート展でも使用された 《夢診断AI SOL-minor》を含め、AIと対話しながら夢からのメッセージや人生へのヒントが得られるテクノロジーの制作を手がける。 ',
        description2: '1979年生まれ。フラワーエッセンスと西洋占星術で「自分を知って心と身体を整える」ために個人鑑定や自分で読めるようになる講座を福岡・愛知で開催するほか、コラム執筆中。プライベートでは1児の母。'
      }],

      // バナー
      //
      // src => バナー画像
      banner: [{
        src: './Images/banner_tvAsahi_2021_ss_v1-3.jpg',
      }],

      // TICKET
      //
      // thumbnail => サムネイル画像
      // title => タイトル
      // description => 詳細説明
      ticket: [{
        thumbnail: './Images/sample_NAKEDURANAI_book_b.jpg',
        term: '2021/6/30(水) 12:00〜7/16(金)23:59',
        date: '7/17(土)〜8/10(火) 入場券',
        notice: '※限定100枚、売り切れ次第終了。',
        price: '5,000円',
      }],

      // オーラ
      //
      // thumbnail => サムネイル画像
      // title => タイトル
      // description => 詳細説明
      aura: [{
        term: '2021/6/30(水) 12:00〜7/16(金)23:59',
        date: '7/17(土)〜8/29(日) 入場券',
        notice: '※限定300枚、売り切れ次第終了。',
        price: '8,000円',
      }],

      // ewaプロフィール
      //
      // thumbnail => サムネイル画像
      // title => タイトル
      // description => 詳細説明
      ewa: [{
        thumbnail: './Images/profile_Ewa.jpg',
        description: 'ewa（エヴァ）1981年生まれ。青山学院大学卒。人や場所を色で感じる「共感覚」を持つ。幼い頃より、その人の持つ資質や心身の状態、場所の持つエネルギーを色を通して感じていたが、25歳頃に自身が見えているのはオーラだと気づく。同時期に自身のアクセサリーブランド「ewa83（エヴァはちさん）」をスタート。石の色の意味や効能を通して、オーラの色がどのような意味を持つのか、自身の体感と知識が結びつくようになる。「ewa83」の展開のひとつとして、その人のオーラを鑑定・状態に合わせたオリジナルアクセサリー制作を行う。口コミで拡がった鑑定実績は500人以上（現在はオーラ鑑定の新規受付休止中）。プライベートでは一女の母であり、某教育出版社で編集者として勤めた会社員時代の経験などを通して、「地に足が着いたオーラ鑑定」を心がけている。'
      }],

      // OUTLINE
      //
      // title => 名称
      // date => 開催期間
      // time => 時間
      // place => 開催場所
      // price => 入場料金
      outline: [{
        title: 'NAKED URANAI（ネイキッドウラナイ）',
        date: '2021年7月17日(土)～2021年8月27日(金)',
        time: '10:00～20:00 (最終入場19:00)',
        map: './Images/img_access_map.png',
      }],

      // 各種SNSのリンク
      //
      // icon => アイコン
      // url => リンク先URL
      links: [{
          icon: './Images/icon_facebook.svg',
          url: 'https://www.facebook.com/NAKEDINC.official/'
        },
        {
          icon: './Images/icon_twitter.svg',
          url: 'https://twitter.com/naked_staff'
        },
        {
          icon: './Images/icon_instagram.svg',
          url: 'https://www.instagram.com/naked_inc/'
        },
      ],

      // Naked Links
      //url => リンク先URL
      nakedlinks: [{
          event: '東京タワー',
          url: 'https://www.tokyotower.co.jp/',
        },
        {
          event: 'マクセル アクアパーク品川',
          url: 'http://www.aqua-park.jp/special/floweraquarium2021/'
        }
      ],


      // いったん以下は使わない
      //windowWidth: window.innerWidth+'px',

      // PCとモバイルを切り替えるためのもの、消さないように
      isMobile,

      isMobileDevice: function () {
        if (isMobile().any) {
          return true;
        }
        return false;
      },

      // デバッグモード判定
      isDebug: false
    }),
  }
</script>



<style lang="scss" scoped>
  html {
    font-family: "Yu Gothic", "Roboto", "Helvetica Neue", "Helvetica", "Hiragino Sans", "Hiragino Kaku Gothic ProN", "Arial", "Meiryo", sans-serif;
  }

  .text-primary {
    color: #00d1d5 !important;
  }

  .border-white {
    border: 2px solid #fff !important;
  }

  .br-sm {
    @media screen and (min-width:735px) {
      display: none;
    }
  }

  .text-indent--05 {
    text-indent: -.5em;
  }

  @mixin text-block {
    max-width: 800px;
  }

  .text-block {
    @include text-block;
  }

  /* bgColor */
  .bgSub {
    background-color: #f2f2f2;
  }

  .bgWht {
    background-color: #ffffff;
    color: #121212;
  }

  .swiper-container {
    height: 300px;
    width: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 38px;
    font-weight: 700;
    background-color: #eee;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-left: 1px solid #fff;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .allow-top {
    display: inline-block;
    font-size: 1em;
    padding: .5em 0 .5em 0;
    transform-origin: center;
    transform: rotate(-90deg);
  }

  .data-list {
    padding-left: 0;

    li {
      list-style: none;
    }
  }

.is-disabled {
  cursor: none;
  pointer-events: none;
}

    /* CLOSED */
    .closed {
      font-size: 24px;
      text-align: center;
      padding: 16px;
      color: #fff;
      background: #000;

      @media screen and (min-width: 600px) {
        font-size: 36px;
      }
  }
</style>